import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Navbar from './components/Navbar';
import Sidebar from './components/Sidebar';
import Footer from './components/Footer';
import AudioPlayer from './components/AudioPlayer';
import { BusinessSettingsProvider } from "./context/BusinessSettingsContext";
import { AudioProvider } from './context/AudioContext';
import Home from './pages/Home';
import AllChannels from './pages/AllChannels';
import About from './pages/About';
import Contact from './pages/Contact';
import Artists from './pages/Artists';
import History from './pages/History';
import LatestChannels from './pages/LatestChannels';
import SingleChannel from './pages/SingleChannel';
import Signin from './pages/Signin';
import Register from './pages/Register';
import Profile from './pages/Users/Profile';
import Search from './pages/Search';
import Countries from './pages/Countries';
import LanguageByChannels from './pages/LanguageByChannels';
import Languages from './pages/Languages';
import SingleCountry from './pages/SingleCountry';
import Collection from './pages/Collections/Collection';
import AllCollections from './pages/Collections/AllCollections';
import LikedChannels from './pages/Users/LikedChannels';
import FavoriteChannels from './pages/Users/FavoriteChannels';
import TopChannels from './pages/Channels/TopChannels';
import MostLikedChannells from './pages/Channels/MostLikedChannels';
import MostFavoriteChannels from './pages/Channels/MostFavoriteChannels';
import AllBlogs from './pages/Blogs/AllBlogs';
import SingleBlogPost from './pages/Blogs/SingleBlogPost';
import SinglePage from './pages/pages/SinglePage';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const App = () => {
    return (
        <AudioProvider>
            <BusinessSettingsProvider>
                <Router>
                    <Navbar />
                        <div style={{ padding: '5px' }}>
                            <Sidebar />
                            <Routes>
                                <Route path="/" element={<Home />} />
                                <Route path="/all-channels" element={<AllChannels />} />
                                <Route path="/about" element={<About />} />
                                <Route path="/contact" element={<Contact />} />
                                <Route path="/artists" element={<Artists />} />
                                <Route path="/latest-channels" element={<LatestChannels />} />
                                <Route path="/top-channels" element={<TopChannels />} />
                                <Route path="/most-liked-channels" element={<MostLikedChannells />} />
                                <Route path="/most-favorite-channels" element={<MostFavoriteChannels />} />
                                <Route path="/history" element={<History />} />
                                <Route path="/channel/:slug" element={<SingleChannel />} />
                                <Route path="/search" element={<Search />} />
                                <Route path="/signin" element={<Signin />} />
                                <Route path="/register" element={<Register />} />
                                <Route path="/profile" element={<Profile />} />
                                <Route path="/liked-channels" element={<LikedChannels />} />
                                <Route path="/favorite-channels" element={<FavoriteChannels />} />
                                <Route path="/languages" element={<Languages />} />
                                <Route path="/language/:language" element={<LanguageByChannels />} />
                                <Route path="/countries" element={<Countries />} />
                                <Route path="/country/:code" element={<SingleCountry />} />
                                <Route path="/blogs" element={<AllBlogs />} />
                                <Route path="/blog/:slug" element={<SingleBlogPost />} />
                                <Route path="/page/:slug" element={<SinglePage />} />
                                <Route path="/collection/:slug" element={<Collection />} />
                                <Route path="/collections" element={<AllCollections />} />
                            </Routes>
                        </div>
                    <Footer />
                </Router>
                <AudioPlayer />
                <ToastContainer />
            </BusinessSettingsProvider>
        </AudioProvider>
    );
};

export default App;
